import React, { useEffect, useState } from 'react';

import Overlay from '../overlays';
import { refsStore, videoStore } from '../../managers/globalState';

import '../../../www/assets/css/chart_overlay.css';

const ChartOverlay = ({ closeOverlay, isMobile }) => {
	const { get } = refsStore.stateSnapshot;
	const videoManager = get('video');
	const { videoId } = videoStore.stateSnapshot;
	const videoObject = videoManager?.getVideo(videoId);
	const videoTypeTitle = videoObject?.dropDownTitle ? videoObject.dropDownTitle : null;

	const [imageSize, setImageSize] = useState([0, 0]);
	const [windowSize, setWindowSize] = useState([0, 0]);

	useEffect(() => {
		const img = document.createElement('img');
		img.src = videoObject.src;
		img.onload = () => {
			setImageSize([img.width, img.height]);
		};

		const updateSize = () => {
			const padding = 25;

			setWindowSize([window.innerWidth - 3 * padding, window.innerHeight - 3 * padding]);
		};
		window.addEventListener('resize', updateSize);
		updateSize();
		return () => window.removeEventListener('resize', updateSize);
	}, []);

	const style = {};
	if (imageSize[0] * imageSize[1] * window.innerWidth * window.innerHeight > 0) {
		const headerBar = document.getElementById('header-bar');
		const headerHeight = headerBar?.clientHeight ? headerBar.clientHeight : 75;

		if ((windowSize[1] - headerHeight) / imageSize[1] * imageSize[0] < windowSize[0]) {
			style.width = Math.round((windowSize[1] - headerHeight) / imageSize[1] * imageSize[0]);
			style.height = Math.round(windowSize[1] - headerHeight);
		} else if (windowSize[0] / imageSize[0] * imageSize[1] < windowSize[1] - headerHeight) {
			style.width = Math.round(windowSize[0]);
			style.height = Math.round(windowSize[0] / imageSize[0] * imageSize[1]);
		}
	}

	return videoId && (
		<Overlay type='chart'>
			<Overlay.Header
				onClose={closeOverlay}
				isMobile={isMobile}
				title={videoTypeTitle}
			>
				{videoObject.title}
			</Overlay.Header>

			<div className='content-mask chart-container'>
				<img src={videoObject.src} style={style} alt={videoObject.title} />
			</div>

		</Overlay>
	);
};

export default ChartOverlay;
